/**
 * Asynchronously loads the component for Materials
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
